import React from 'react';
import './ContactUs.css';

const ContactUs = ({ toggleContactUs }) => {

  const handleSubmit = (evt) => {
    evt.preventDefault();

    var xhr = new XMLHttpRequest(),
      params = [
        encodeURIComponent('Form_ID') + '=' + encodeURIComponent('eastend_contact_us'),
        encodeURIComponent('Owner_ID') + '=' + encodeURIComponent('rnelson2'),
        encodeURIComponent('send_submit') + '=' + encodeURIComponent('data'),
        encodeURIComponent('send_submit_to') + '=' + encodeURIComponent('rnelson2, jkeefer, ebaughan'),
        encodeURIComponent('project') + '=' + encodeURIComponent('eastend_contact_form'),
        encodeURIComponent('name') + '=' + encodeURIComponent(evt.target.name.value),
        encodeURIComponent('email') + '=' + encodeURIComponent(evt.target.email.value),
        encodeURIComponent('message') + '=' + encodeURIComponent(evt.target.message.value)
      ].join('&');

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4 && xhr.status === 200) {
        document.getElementsByClassName("contactUsForm")[0].innerHTML = "<p>We have received your message. Thank you for contacting us.</p>";
      }
    };

    xhr.open("POST", 'https://webapps.richmond.edu/URPoster/URPoster.php');
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.send(params);


    return false;
  };

  return (
     <div className='contactUs'>
      <button
        onClick={toggleContactUs}
        className='close'
      >
        x
      </button>

      <h2>Contact Us</h2>
      <div className='contactUsForm'>
        <form name='eastend_contact_us' onSubmit={handleSubmit }>
          <label htmlFor='name'>Name</label>
          <div><input type='text' maxLength={50} name='name' /></div>
          <label htmlFor='email'>Email</label>
          <div><input type='text' maxLength={50} name='email' /></div>
          <label htmlFor='email'>Message</label>
          <div><textarea name="message" /></div>
          <input type="submit" />
        </form>
      </div>
    </div>
  );
};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/ContactUs.jsx